<template lang="pug">

   MDashboardWidget( title="Compare Batches Report" )

    div(class="form-group row")

        div(class="col-sm-10")
          label Batch Id(s)
          input(type="text" placeholder="Enter Batch ID" class="form-control" v-model="generateBatchId") 

          p( class="text-left mt-3" )
          button( class="btn btn-details btn-outline btn-info" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Generate CSV for download
          
          p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}
    
</template>
<style scoped>

</style>
<script>
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      generateBatchId: "",
      loading: false,
      errorMessage: ''
    };
  },
  
})
</script>